/** A file already stored in the conversation's Project; messages carry paths, never bytes. */
export interface StoredAttachment {
  name: string;
  path: string;
  relative: string;
}

export function composeAttachmentMessage(
  typed: string,
  attachments: readonly StoredAttachment[],
  labels: { attachOnly: string; attachedFile: string },
): { text: string; display: string } {
  return {
    text: [
      typed || labels.attachOnly,
      ...attachments.map((attachment) => `\n[📎 ${labels.attachedFile}: ${attachment.path}]`),
    ].join('\n'),
    display: [typed || labels.attachOnly, ...attachments.map((attachment) => `+ ${attachment.name}`)].join('\n'),
  };
}
